/**
 * LanguageSwitcher Component
 * Toggle between ES/EN languages
 */
import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';

const LanguageSwitcher = ({ className }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'es';

  const languages = [
    { code: 'es', label: 'ES' },
    { code: 'en', label: 'EN' },
  ];

  const handleChange = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('preferredLanguage', langCode);
  };

  return (
    <div
      className={cn(
        'inline-flex items-center rounded-full p-1',
        'bg-neutral-100 dark:bg-neutral-800',
        className
      )}
    >
      {languages.map((lang) => {
        const isSelected = currentLang === lang.code;

        return (
          <motion.button
            key={lang.code}
            onClick={() => handleChange(lang.code)}
            whileHover={{ scale: isSelected ? 1 : 1.05 }}
            whileTap={{ scale: 0.95 }}
            className={cn(
              'relative px-3 py-1.5 text-sm font-medium transition-colors duration-200',
              isSelected
                ? 'text-white'
                : 'text-neutral-600 hover:text-neutral-900 dark:text-neutral-400 dark:hover:text-white'
            )}
          >
            {isSelected && (
              <motion.div
                layoutId="language-pill"
                className="absolute inset-0 rounded-full bg-primary-500"
                transition={{ type: 'spring', duration: 0.4 }}
              />
            )}
            <span className="relative z-10">{lang.label}</span>
          </motion.button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
